import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

interface UseClientUserResetDriverAppPinProps {
  userId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useClientUserResetDriverAppPin = ({ userId, onSuccess, onError }: UseClientUserResetDriverAppPinProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientUserResetDriverAppPin', userId],
    mutationFn: async () => {
      return await privateAxios.post(`/client/users/${userId}/reset_driver_app_pin`);
    },
    onSuccess,
    onError,
  });
};
